<template>
  <div>
    <md-dialog :md-active.sync="isVisible" v-if="visible">
      <h5 :class="alert" v-if="isSubmitted" v-text="resultMessage"></h5>

      <md-dialog-content>
        <group-card title="Upload New Documents" icon="file_upload" :loading="uploading_documents">
            <div class="md-layout">
            <!-- File -->
            <div class="md-layout-item md-small-size-100 md-size-95 dragdrop" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                <i class="material-icons text_align-center">backup</i>
                <label for="assetsFieldHandle" class="block cursor-pointer">
                <div>
                    <p>Drag and drop file here to upload document</p>
                    <p>or</p>
                </div>
                </label>
                <ValidationProvider v-slot="{ failed, validate }"
                                    rules="mimes:text/plain"
                >
                <input type="file"
                        multiple="false"
                        @change="onFileChange"
                        id="assetsFieldHandle"
                        ref="file"
                        :accept="supportedExt"
                />
                <span v-if="failed" class="error-msg">Only {{ supportedExt }} files accepted.</span>
                </ValidationProvider>
            </div>

            </div>
            <div class="md-layout">

            </div>
            <!-- <md-dialog-alert
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content" /> -->
        </group-card>
      </md-dialog-content>

      <md-dialog-actions>
        <loading-icon-text-button class="md-primary md-simple" @click="onCancel">Cancel</loading-icon-text-button>
        <loading-icon-text-button
          class="md-primary md-simple"
          @click="onUpload"
          icon="file_upload"
          :loading="uploading_documents"
          :class="{disabled:invalid}">
          Upload
        </loading-icon-text-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import ValidatedInputs from "@/components/ValidatedInput";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import { GroupCard } from "@/components";

export default {
  components:{
    LoadingIconTextButton,
    GroupCard,
    ...ValidatedInputs,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    supportedExt: {
      required: false,
      type: Array,
    },
  },
  data(){
    return{
      isSaving: false,
      isSubmitted: false,
      alert: 'upload_alert',
      resultMessage: '',
      selected_doucments: [],
      uploading_documents: false,
      invalid: false,
      supported_file_extensions: []
    }
  },
  computed: {
    isVisible:{
      get(){
        return this.visible;
      },
      set(value){
        this.$emit("onCancel", value);
      }
    },
  },
  methods:{
    onCancel() {
      this.isVisible = false;
      this.selected_doucments = [];
    },
    onFileChange(event, index) {
        this.documents = event.target.files[0];
    },
    async onUpload() {
        this.uploading_documents = true;

        let form_data = new FormData();
        form_data.append("file", this.documents);

      try {
        let dispatchType = "upload_hem_living_expense";
        await this.$store.dispatch(dispatchType, form_data);

        this.isSubmitted = true;
        this.alert = 'upload_alert';
        this.resultMessage = 'The hem living expense file has been uploaded';
        this.uploading_documents = false;
        this.$emit("successUpload");

      } catch (e) {
        console.error(e);
        this.isSubmitted = true;
        this.alert = 'upload_error';
        this.resultMessage = e.response.data;
        this.uploading_documents = false;
      }
    },
    dragover(event) {
        event.preventDefault();
        // Add some visual fluff to show the user can drop its files
        if (!event.currentTarget.classList.contains('bg-green-300')) {
            event.currentTarget.classList.remove('bg-gray-100');
            event.currentTarget.classList.add('bg-green-300');
        }
    },
    dragleave(event) {
        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
    },
    drop(event) {
        event.preventDefault();
        this.$refs.file.files = event.dataTransfer.files;
        this.file = event.dataTransfer.files[0];
        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/theme.scss';
    .upload_alert {
        border: 0;
        position: relative;
        padding: 20px 15px;
        line-height: 20px;
        margin-bottom: 20px;
        z-index: 99999 !important;
        background-color: #0b0e3c;
        color: #FFFFFF;
        border-radius: 3px;
        box-shadow: 0 12px 20px -10px rgb(153 153 153 / 28%), 0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(153 153 153 / 20%);
    }

    .upload_error {
        border: 0;
        position: relative;
        padding: 20px 15px;
        line-height: 20px;
        margin-bottom: 20px;
        z-index: 99999 !important;
        background-color: #e31854;
        color: #FFFFFF;
        border-radius: 3px;
        box-shadow: 0 12px 20px -10px rgb(153 153 153 / 28%), 0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(153 153 153 / 20%);
    }
    .dragdrop {
        background: #EEEEEE; /* and other things to make it pretty */
        outline: 2px dashed #cccccc;
        margin: 15px 15px 0 15px;
        text-align: center;
    }
    .dragdrop i {
        color: $ausloans-blue !important;
        font-size: 4em;
    }
    .file-wrapper input {
        cursor: pointer;
        opacity: 0.0;
        filter: alpha(opacity=0);
    }
    .bg-green-300 {
        background: #a5d7ff;
    }
    .bg-gray-100 {
        background: #EEEEEE;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .dragdrop input[type=file] {
        width: 100%;
        margin-bottom: 10px;
    }
    input[type=file]::file-selector-button{
        background: $ausloans-blue;
        border:none;
        color:white;
        padding:6px 8px;
        cursor: pointer;
        border-radius: 3px;
    }
</style>
